import type {CSSProperty} from '../types';

export const PROPERTIES_WITH_SINGLE_UNIT: CSSProperty[] = [
    'width',
    'height',

    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',

    'fontSize',
    'lineHeight',
    'letterSpacing',

    'borderTopLeftRadius',
    'borderTopRightRadius',
    'borderBottomLeftRadius',
    'borderBottomRightRadius',

    'borderTopWidth',
    'borderRightWidth',
    'borderBottomWidth',
    'borderLeftWidth',

    'top',
    'right',
    'bottom',
    'left',

    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',

    'columnGap',
    'rowGap',
    'gap',

    'minWidth',
    'maxWidth',
    'minHeight',
    'maxHeight',
];

export type SizeUnit = 'px' | 'em' | 'rem' | 'vw' | 'vh' | '%' | 'auto';

export const DROPDOWN_UNITS: {
    units: Array<{value: SizeUnit; label: string}>;
} = {
    units: [
        {value: 'px', label: 'px'},
        {value: '%', label: '%'},
        {value: 'em', label: 'em'},
        {value: 'rem', label: 'rem'},
        {value: 'vw', label: 'vw'},
        {value: 'vh', label: 'vh'},
        {value: 'auto', label: 'auto'},
    ],
};
